'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $is_Lapp_pages_AppPage$HasChatId(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.ancestors.Lapp_pages_AppPage$HasChatId)));
}
export { $is_Lapp_pages_AppPage$HasChatId as $is_Lapp_pages_AppPage$HasChatId };
function $isArrayOf_Lapp_pages_AppPage$HasChatId(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$HasChatId)));
}
export { $isArrayOf_Lapp_pages_AppPage$HasChatId as $isArrayOf_Lapp_pages_AppPage$HasChatId };
//# sourceMappingURL=app.pages.-App-Page$-Has-Chat-Id.js.map
